export default {
  title: 'Actualizări',
  fields: {
    app_version: 'Versiune Aplicație',
    description: 'Descriere',
    created_at: 'Creat la',
  },
};
